import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Privacy from "./pages/Privacy/Privacy";
import NoPage from "./pages/NoPage/NoPage";

import Navbar from "./components/Navbar/Navbar";

function App() {
  return (
    <div>
      {/* <Navbar></Navbar> */}
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/privacy" element={<Privacy />}></Route>
          <Route path="*" element={<NoPage />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
